"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
if (window.__CONFIG__) {
    __webpack_public_path__ = (0, helpers_1.ensureSlash)(window.__CONFIG__.platform.publicUrl);
}
//# sourceMappingURL=setPublicPath.js.map